import React from 'react';
import styles from './style.module.css';

const HeaderSmallEllipse = () => (
  <svg width="16" height="34" viewBox="0 0 16 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.37484e-06 17C5.54037e-07 7.61116 -1.11351e-07 1.39876e-06 -1.11351e-07 1.39876e-06C8.83655 6.26248e-07 16 7.61116 16 17C16 26.3888 8.83656 34 2.86102e-06 34C2.86102e-06 34 2.19563e-06 26.3888 1.37484e-06 17Z" className={styles.effectFill} />
  </svg>
);

export default HeaderSmallEllipse;